import { FC } from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Outlet } from 'react-router-dom';
import { HeaderMonitoring } from './header/Header';

export const MonitoringWrapper: FC = () => {
  return (
    <div className="w-full flex flex-col h-screen">
      <HeaderMonitoring />
      <div className="flex-1 overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
};
